import { render } from "./PrintIcon.vue?vue&type=template&id=42b0313d"
import script from "./PrintIcon.vue?vue&type=script&lang=js"
export * from "./PrintIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__